import { render, staticRenderFns } from "./AccountStatementReport.yaml?vue&type=template&id=f39fd710&component"
import script from "./AccountStatementReport.yaml?vue&type=script&lang=ts&component"
export * from "./AccountStatementReport.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports